import { Box, IconButton } from "@mui/joy";
import { Outlet, useLocation, useNavigate } from "react-router";

import { motion } from "framer-motion";
import { useContext, useEffect, useRef } from "react";
import Sidebar from "../components/ui/Sidebar";
import { List as ListIcon, ArrowLeft } from "@phosphor-icons/react";
import { toggleSidebar } from "../utils";
import { LayoutContext } from "../context";
import TrialBanner from "../components/ui/TrialBanner";
import PaywallScreen from "../components/ui/PaywallScreen";
import UpgradeModal from "../components/modals/UpgradeModal";



export default function Layout() {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, trialInfo } = useContext(LayoutContext);

    useEffect(() => {
      console.log("Путь изменился на:", location.pathname);
    }, [location]);

    const scrollContainerRef = useRef(null);

    const isHome = location.pathname === '/';

    // Hard paywall: expired юзеры (не админы) видят только PaywallScreen.
    // Правило из фидбека "никогда не оставлять empty state" — экран сразу
    // ведёт в UpgradeModal, а не просто блокирует навигацию.
    // tg_promo юзеры (Telegram-подписчики закрытого класса) — bypass: у них всегда
    // открыты БХ/Иммунка/Кардио, hard paywall показывать не надо.
    const isAdmin = user?.role === 'admin';
    const isTgPromo = trialInfo?.is_tg_promo === true;
    // Платным (оплачен инвойс, в т.ч. ждущий активации) paywall не показываем —
    // иначе оплативший с истёкшим триалом не дойдёт до главной, чтобы активировать.
    const isPaid = trialInfo?.has_paid_invoice === true;
    const showPaywall = !isAdmin && !isTgPromo && !isPaid && trialInfo?.state === 'expired';

    return (
        <Box sx={{ display: 'flex', height: '100dvh' }}>
            <Sidebar />

            {/* Mobile nav buttons — fixed top-left, hidden on desktop */}
            <Box sx={{
                display: { xs: 'flex', lg: 'none' },
                position: 'fixed',
                top: 12,
                left: 12,
                zIndex: 999,
                gap: 0.75,
                alignItems: 'center',
            }}>
                {!isHome && (
                    <IconButton
                        onClick={() => navigate(-1)}
                        variant="outlined"
                        color="neutral"
                        size="sm"
                        sx={{ bgcolor: 'background.surface', boxShadow: 'sm' }}
                    >
                        <ArrowLeft size={18} />
                    </IconButton>
                )}
                <IconButton
                    onClick={() => toggleSidebar()}
                    variant="outlined"
                    color="neutral"
                    size="sm"
                    sx={{ bgcolor: 'background.surface', boxShadow: 'sm' }}
                >
                    <ListIcon size={18} />
                </IconButton>
            </Box>
            <Box
                className="MainContent"
                sx={{
                    flex: 1,
                    minWidth: 0,
                    overflow: 'hidden',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {/* Trial banner: sticky сверху, виден только в active_trial state. */}
                <TrialBanner />

                <motion.main
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.2, ease: "easeOut" }}
                    style={{ overflowX: 'hidden', flex: 1 }}
                >
                    <Outlet context={{ scrollContainerRef }}/>
                </motion.main>
            </Box>

            {/* Upgrade modal — глобальный, открывается из TrialBanner, PaywallScreen,
                и через openUpgradeModal() из любого места (например, при 403 trial_locked). */}
            <UpgradeModal />

            {/* Hard paywall: поверх всего для expired юзеров. Рендерим в самом конце,
                чтобы точно перекрывал всё остальное. */}
            {showPaywall && <PaywallScreen />}
        </Box>
    );
}
